// extracted by mini-css-extract-plugin
export var altaccent = "MinimalFooter-module--altaccent--fba66";
export var columnsWrapper = "MinimalFooter-module--columns-wrapper--f1dcc";
export var copyright = "MinimalFooter-module--copyright--97a5d";
export var footer = "MinimalFooter-module--footer--d5600";
export var groupLogo = "MinimalFooter-module--group-logo--02d48";
export var layout = "MinimalFooter-module--layout--768b4";
export var layoutColumns = "MinimalFooter-module--layout-columns--225e1";
export var light = "MinimalFooter-module--light--04774";
export var link = "MinimalFooter-module--link--6f6ef";
export var list = "MinimalFooter-module--list--441da";
export var logo = "MinimalFooter-module--logo--d84eb";
export var platform = "MinimalFooter-module--platform--086f1";
export var small = "MinimalFooter-module--small--d8b21";
export var socialIcon = "MinimalFooter-module--social-icon--7faec";
export var subNavigation = "MinimalFooter-module--sub-navigation--1916f";